import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";
import { useContext, useEffect, useState } from 'react';
import { SplitViewContext, WebEditorContext } from '../../../../contexts';
import * as Constants from "../../../../utils/constants";
import "./styles.scss"

export default function MandatoryFieldBanner({ nav }) {
    const { t: te } = useTranslation([resources.edit]);
    const { formikValues, editorFileRef } = useContext(WebEditorContext);
    const { rightPaneWidth: editorPaneWidth } = useContext(SplitViewContext);
    const [open, setOpen] = useState(false);
    const [currentFieldId, setCurrentFieldId] = useState();

    const handleMandatoryFields = () => {
        if (!editorFileRef.current || !editorFileRef.current.EditorInputFields || editorFileRef.current.EditorInputFields.length === 0 || !formikValues) {
            setOpen(false);
            return;
        }

        let hasEmptyMandatoryField = false;
        const mandatoryFields = editorFileRef.current.EditorInputFields.filter(x => x.ValidationRule?.NotEmpty);
        for (const editorInputField of mandatoryFields) {
            // Check if the field is in a selectable text
            if (editorInputField.EditorTextPartId) {
                // The selectable text is selected
                if (formikValues[editorInputField.EditorTextPartId]) {
                    if (!formikValues[editorInputField.Id]) {
                        hasEmptyMandatoryField = true;
                        break;
                    }
                }
            } else {
                if (!formikValues[editorInputField.Id]) {
                    hasEmptyMandatoryField = true;
                    break;
                }
            }
        }
        setOpen(hasEmptyMandatoryField);
    }

    useEffect(() => {
        handleMandatoryFields();
    }, [formikValues])

    const handleMoveDown = () => {
        if (!editorFileRef.current || !editorFileRef.current.EditorInputFields || editorFileRef.current.EditorInputFields.length === 0 || !formikValues)
            return;

        let nextIndex;
        const foundCurrentFieldIndex = editorFileRef.current.EditorInputFields.findIndex(x => x.Id === currentFieldId);
        if (foundCurrentFieldIndex < 0) {
            nextIndex = 0;
        } else {
            if ((foundCurrentFieldIndex + 1) >= editorFileRef.current.EditorInputFields.length)
                nextIndex = 0;
            else
                nextIndex = foundCurrentFieldIndex + 1;
        }

        let fields = editorFileRef.current.EditorInputFields;
        if (nextIndex > 0) {
            fields = editorFileRef.current.EditorInputFields.slice(nextIndex);
            fields = fields.concat(editorFileRef.current.EditorInputFields.slice(0, nextIndex));
        }

        for (const editorInputField of fields) {
            if (editorInputField.ValidationRule?.NotEmpty && !formikValues[editorInputField.Id]) {
                const fieldElement = document.getElementById(editorInputField.Id);
                if (fieldElement) {
                    fieldElement.focus();
                    setCurrentFieldId(editorInputField.Id);
                    break;
                }
            }
        }
    }

    const handleMoveUp = () => {
        if (!editorFileRef.current || !editorFileRef.current.EditorInputFields || editorFileRef.current.EditorInputFields.length === 0 || !formikValues)
            return;

        let previousIndex;
        const foundCurrentFieldIndex = editorFileRef.current.EditorInputFields.findIndex(x => x.Id === currentFieldId);
        if (foundCurrentFieldIndex < 0) {
            previousIndex = 0;
        } else {
            if ((foundCurrentFieldIndex - 1) < 0)
                previousIndex = editorFileRef.current.EditorInputFields.length - 1;
            else
                previousIndex = foundCurrentFieldIndex - 1;
        }

        let fields = editorFileRef.current.EditorInputFields;
        if (previousIndex >= 0) {
            fields = editorFileRef.current.EditorInputFields.slice(previousIndex + 1);
            fields = fields.concat(editorFileRef.current.EditorInputFields.slice(0, previousIndex + 1));
        }
        fields = fields.reverse();

        for (const editorInputField of fields) {
            if (editorInputField.ValidationRule?.NotEmpty && !formikValues[editorInputField.Id]) {
                const fieldElement = document.getElementById(editorInputField.Id);
                if (fieldElement) {
                    fieldElement.focus();
                    setCurrentFieldId(editorInputField.Id);
                    break;
                }
            }
        }
    }

    if (nav !== Constants.menuState.edit || !open) {
        return <></>
    }

    return (
        <div className="tw-bg-#fdf4d7 tw-px-6 tw-py-4 tw-mb-3 tw-border">
            <div className={`${(!editorPaneWidth || (editorPaneWidth > 640)) ? "md:tw-flex md:tw-justify-between" : ""} tw-items-center`}>
                <p className="tw-text-gray-700 tw-text-sm tw-font-medium">{te(translations.edit.mandatoryFieldBanner.message)}</p>
                <p className="md:tw-hidden">&nbsp;</p>
                <div className={`tw-flex tw-items-center tw-gap-x-5 ${(!editorPaneWidth || (editorPaneWidth > 200)) ? "tw-flex-row" : "tw-flex-col"}`}>
                    <span className="tw-text-gray-700 tw-text-sm tw-font-medium">{te(translations.edit.mandatoryFieldBanner.browse)}</span>
                    <div className={`tw-flex tw-gap-x-3 ${(!editorPaneWidth || (editorPaneWidth > 200)) ? "tw-flex-row" : "tw-flex-col"}`}>
                        <MandatoryFieldButton
                            label={te(translations.edit.mandatoryFieldBanner.moveDown)}
                            onClick={handleMoveDown}>
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="down" className="tw-h-5 tw-w-6" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                <path fill="currentColor" d="M192 429.6L49.3 279.7c-.8-.8-1.3-2-1.3-3.2c0-2.5 2-4.6 4.6-4.6l83.4 0c13.3 0 24-10.7 24-24l0-168 64 0 0 168c0 13.3 10.7 24 24 24l83.4 0c2.5 0 4.6 2 4.6 4.6c0 1.2-.5 2.3-1.3 3.2L192 429.6zM0 276.6c0 13.5 5.2 26.5 14.5 36.3L161.1 466.8c8.1 8.5 19.2 13.2 30.9 13.2s22.8-4.8 30.9-13.2L369.5 312.8c9.3-9.8 14.5-22.8 14.5-36.3c0-29-23.5-52.6-52.6-52.6L272 224l0-144c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48l0 144-59.4 0C23.5 224 0 247.5 0 276.6z"></path>
                            </svg>
                        </MandatoryFieldButton>
                        <MandatoryFieldButton
                            label={te(translations.edit.mandatoryFieldBanner.moveUp)}
                            onClick={handleMoveUp}>
                            <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="up" className="tw-h-5 tw-w-6" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                <path fill="currentColor" d="M192 82.4L334.7 232.3c.8 .8 1.3 2 1.3 3.2c0 2.5-2 4.6-4.6 4.6L248 240c-13.3 0-24 10.7-24 24l0 168-64 0 0-168c0-13.3-10.7-24-24-24l-83.4 0c-2.5 0-4.6-2-4.6-4.6c0-1.2 .5-2.3 1.3-3.2L192 82.4zm192 153c0-13.5-5.2-26.5-14.5-36.3L222.9 45.2C214.8 36.8 203.7 32 192 32s-22.8 4.8-30.9 13.2L14.5 199.2C5.2 208.9 0 221.9 0 235.4c0 29 23.5 52.6 52.6 52.6l59.4 0 0 144c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-144 59.4 0c29 0 52.6-23.5 52.6-52.6z"></path>
                            </svg>
                        </MandatoryFieldButton>
                    </div>
                </div>
            </div>
        </div>
    )
}

const MandatoryFieldButton = ({ label, onClick, children }) => {
    return (
        <button
            type="button"
            aria-label={label}
            className="button-tooltip-container tw-w-9 tw-h-8 tw-bg-white tw-flex tw-items-center tw-justify-center tw-text-gray-500 
                tw-border tw-border-gray-300 tw-rounded-md hover:tw-text-gray-600 hover:tw-bg-gray-50 
                focus:tw-outline-none focus:tw-border-indigo-600 focus:tw-ring-indigo-600 focus:tw-ring-2"
            onClick={onClick}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            {children}
            <span role="tooltip" id="preview-tooltip-desc" className="button-tooltip">{label}</span>
        </button>
    )
} 